// extracted by mini-css-extract-plugin
module.exports = {"image":"FlightsInterlinkingItem-module__image___JCkCM","text":"FlightsInterlinkingItem-module__text___eS0J2"};